/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Adjust_TargetInputs */

const vi_customer_debt_adjust_target = /** @type {(inputs: Customer_Debt_Adjust_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số dư đích`)
};

/**

* @param {Customer_Debt_Adjust_TargetInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_adjust_target = /** @type {((inputs?: Customer_Debt_Adjust_TargetInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Adjust_TargetInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_adjust_target(inputs)
});